// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"dca-z","disabled":"eca-z","label":"fca-z"};